import React from 'react';
import { Grid } from '@lionstep/ui';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './generateTextDrawer.module.scss';

export const QUESTIONS_OPTIONS = {
  boolean: 'Yes/No',
  multiple_choices: 'Multiple Choice',
  skills: 'Skills',
  text: 'Open Answer',
};

const QuestionList = ({ questions }) =>
  questions?.map((question, index) => (
    <div key={index} className={styles.questionItem}>
      <div className={styles.questionTitle}>
        {index + 1}. {question.title} (
        {QUESTIONS_OPTIONS[question.question_type]})
      </div>
      {question.question_type !== 'boolean' && (
        <ul className={styles.questionChoices}>
          {question.choices?.map((choice, choiceIndex) => (
            <li key={choiceIndex} className={styles.choiceItem}>
              {choice.choice}
            </li>
          ))}
        </ul>
      )}
    </div>
  ));

const GeneratedQuestionsItem = ({ title, current, generated }) => (
  <Grid.Row className={styles.generatedTextItem} gutter={16}>
    <Grid.Col xs={24} className={styles.generatedTextItemTitle}>
      {title}
    </Grid.Col>
    <Grid.Col xs={12} className={styles.generatedTextItemTitleSecondary}>
      Current
    </Grid.Col>
    <Grid.Col xs={12} className={styles.generatedTextItemTitleSecondary}>
      Generated
    </Grid.Col>
    <Grid.Col xs={12} className={styles.generatedTextItemContent}>
      <QuestionList questions={current} />
    </Grid.Col>
    <Grid.Col xs={12} className={styles.generatedTextItemContent}>
      <QuestionList questions={generated} />
    </Grid.Col>
  </Grid.Row>
);

const GeneratedQuestionsDisplay = ({
  killerQuestions,
  optionalQuestions,
  generatedText,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {killerQuestions && killerQuestions.length > 0 && (
        <>
          <GeneratedQuestionsItem
            title={t('killer_questions.title')}
            current={killerQuestions}
            generated={generatedText?.questions?.killer_questions}
          />
          {optionalQuestions?.length > 0 && (
            <Grid.Row>
              <Grid.Col xs={24}>
                <div className={styles.divider} />
              </Grid.Col>
            </Grid.Row>
          )}
        </>
      )}

      {optionalQuestions && optionalQuestions.length > 0 && (
        <GeneratedQuestionsItem
          title={t('optional_questions.title')}
          current={optionalQuestions}
          generated={generatedText?.questions?.optional_questions}
        />
      )}
    </>
  );
};

export default GeneratedQuestionsDisplay;

